import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/system'

export const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(5, 3, 0),
  height: '100%',
  '& > .MuiGrid-container': {
    height: '100%',
  },
  position: 'relative',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 2, 0),
  },
}))

export const ChildrenContainer = styled(Grid)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(2),
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '48px',
  fontWeight: 500,
  letterSpacing: '-2px',
  lineHeight: '50px',
  margin: '0px 0px 16px',

  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    lineHeight: '26px',
    letterSpacing: '-1px',
    margin: '0px',
  },
}))
